import { ALL_ACTIONS } from "@/utils/wellnessActions";

export const MAIN_CATEGORIES = ALL_ACTIONS;

const normalizedCategories = new Set(MAIN_CATEGORIES.map(c => c.trim().toLowerCase()));

const getCategory = (action) => {
  if (!action) return "Other";
  const key = action.trim().toLowerCase();
  return normalizedCategories.has(key)
    ? MAIN_CATEGORIES.find(cat => cat.trim().toLowerCase() === key)
    : "Other";
};

export const getTopHelpfulActionsByEmotion = (dataPoints) => {
  const emotionMap = {};
  const globalActions = {};

  for (const dp of dataPoints) {
    if (!dp.helpful || !dp.action || !dp.emotion) continue;

    const emotion = dp.emotion.trim().toLowerCase();
    const category = getCategory(dp.action);

    if (!emotionMap[emotion]) emotionMap[emotion] = {};
    emotionMap[emotion][category] = (emotionMap[emotion][category] || 0) + 1;

    globalActions[category] = (globalActions[category] || 0) + 1;
  }

  const perEmotionResult = {};
  for (const [emotion, actions] of Object.entries(emotionMap)) {
    const sorted = Object.entries(actions).sort((a, b) => b[1] - a[1]);
    perEmotionResult[emotion] = {
      topAction: sorted[0]?.[0] || "—",
      allActions: sorted
    };
  }

  return {
    perEmotion: perEmotionResult,
    globalActions
  };
};